import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { btn, field } from "@/components/ui-kit";

export const ChangePasswordDialog = ({ open, onClose, forced }) => {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const save = async () => {
    if (nw !== cf) return toast.error("New passwords do not match");
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password changed");
      setCur(""); setNw(""); setCf("");
      onClose(true);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && !forced && onClose(false)}>
      <DialogContent className="max-w-md border-slate-800 bg-[#1F232C] text-slate-100" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Change password</DialogTitle>
          <DialogDescription className={forced ? "text-amber-300" : "text-slate-400"}>{forced ? "You are using a temporary password. Please set your own to continue." : "Use at least 8 characters."}</DialogDescription>
        </DialogHeader>
        <Input type="password" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} className={field} data-testid="cp-current-input" />
        <Input type="password" placeholder="New password (8+ characters)" value={nw} onChange={(e) => setNw(e.target.value)} className={field} data-testid="cp-new-input" />
        <Input type="password" placeholder="Confirm new password" value={cf} onChange={(e) => setCf(e.target.value)} className={field} data-testid="cp-confirm-input" />
        <Button onClick={save} className={btn.primary} data-testid="cp-save-btn">Save password</Button>
      </DialogContent>
    </Dialog>
  );
};
